import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import App from './app/app';
import { configureTinyMce } from '@sm-dashboard/form-provider';
import { cacheRtl, theme } from './theme/theme';
import { CssBaseline } from '@mui/material';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import { AppContextProvider } from './context/AppContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './react-query';
import { getUrls } from '@/util/urls';

import './main.css';
import { setAppViewportHeight } from '@/hooks/useAppViewportHeight';

setAppViewportHeight();

configureTinyMce({
  baseUrl: getUrls().backendUrl,
  apiKey: (import.meta as { env?: { VITE_TINY_KEY?: string } }).env?.VITE_TINY_KEY
});
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const ThemeProviderWrapper = () => {
  return (
    <AppContextProvider>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <CssBaseline />
          <App />
        </ErrorBoundary>
      </ThemeProvider>
    </AppContextProvider>
  );
};

root.render(
  <StrictMode>
    <BrowserRouter>
      <CacheProvider value={cacheRtl}>
        <QueryClientProvider client={queryClient}>
          <ThemeProviderWrapper></ThemeProviderWrapper>
        </QueryClientProvider>
      </CacheProvider>
    </BrowserRouter>
  </StrictMode>
);
